import React, { FC } from "react"

import { SelectOption } from "src/components/common/select"

import { Country, useCountries } from "src/states/countries"
import { useNomenclature } from "src/states/nomenclature"
import { useOptionsets } from "src/states/optionsets"
import { Region, useRegions } from "src/states/regions"
import { TranslationMessages } from "src/translations"

import { AdvancedFormData } from "./AdvancedForm"
import { AdvancedFormField, AdvancedFormFieldProps } from "./AdvancedFormField"

export type AdvancedFormFieldsProps = {
  activeStep?: number
  id?: string
  data: AdvancedFormData
  formId: string
  formDisabled?: boolean
  formMessages?: any
  messages?: TranslationMessages
  fields?: AdvancedFormFieldProps[]
  containerClassName?: string
  updateFieldState: (value: AdvancedFormFieldProps, name?: string) => void
}

export const AdvancedFormFields: FC<AdvancedFormFieldsProps> = ({
  id,
  activeStep,
  data,
  formId,
  formDisabled,
  formMessages,
  messages,
  fields,
  updateFieldState,
  containerClassName,
}) => {
  const countries = useCountries()
  const regions = useRegions()
  const nomenclature = useNomenclature()
  const {
    languages,
    academicTitles,
    companyTypes,
    ustDeclarations,
    salutations,
  } = useOptionsets()
  if (!fields || fields?.length === 0) {
    return null
  }
  let fieldArray = [...fields]
  return (
    <div className={containerClassName}>
      {fieldArray.map((fieldData) => {
        let Field = JSON.parse(JSON.stringify(fieldData))
        delete Field?.defaultConditions
        delete Field?.referenceType
        const {
          field,
          type,
          value,
          description,
          name = "",
          helperText,
          label,
          items,
          disabled,
        } = fieldData
        let Value = value

        // // Set default value
        // const cart = getCarts().carts.find((cart) => cart.id === id)
        // if (cart) {
        //   const products = cart.products ?? []
        //   const productAttribute = products[0].productAttributeValues ?? []
        //   const attrValue = productAttribute.find(
        //     (attribute) => attribute.field === field,
        //   )?.value
        //   if (attrValue && !Value) {
        //     Value = `${attrValue}`
        //   }
        // }

        if (
          typeof value === "object" &&
          !Array.isArray(value) &&
          value !== null &&
          "value" in value
        ) {
          Value = value.value
        }
        const Disabled = disabled ?? formDisabled ?? false
        let Items = items ?? []
        const Name = `${formId}/${fieldData?.id ?? name}/${field}`

        let Label
        if (activeStep !== undefined) {
          Label =
            label ??
            (formMessages?.[data?.[activeStep]?.id]?.[formId] as any)?.fields?.[
              name ?? ""
            ] ??
            undefined
        } else {
          Label =
            label ??
            (formMessages?.[formId] as any)?.fields?.[name ?? ""] ??
            undefined
        }
        let HelperText =
          (formMessages?.[formId] as any)?.[`${name}HelperText`] ?? helperText
        let Description =
          description ??
          (formMessages?.[formId] as any)?.fields?.[`${name}Description`]
        if (!items || items?.length === 0) {
          switch (type?.toLowerCase()) {
            case "country":
              Items = countries as SelectOption[]
              Value = countries?.find(
                (el: Country) => el.key === Value,
              ) as SelectOption
              break
            case "region":
              Items = regions as SelectOption[]
              Value = regions?.find(
                (el: Region) => el.key === Value,
              ) as SelectOption
              break
            case "nomenclature":
              Items = nomenclature as SelectOption[]
              break
            case "languages":
              Items = languages as SelectOption[]
              break
            case "academictitle":
              Items = academicTitles as SelectOption[]
              Value = academicTitles?.find(
                (el) => el.key === Value,
              ) as SelectOption
              break
            case "companytype":
              Items = companyTypes as SelectOption[]
              break
            case "ustdeclarations":
              Items = ustDeclarations as SelectOption[]
              break
            case "salutation":
              Items = salutations as SelectOption[]
              break
            default:
              Items = []
              break
          }
        }
        return (
          <AdvancedFormField
            {...Field}
            key={Name}
            description={Description}
            disabled={Disabled}
            helperText={HelperText}
            id={id}
            items={Items}
            label={Label}
            messages={messages}
            name={Name}
            updateFieldState={updateFieldState}
            value={Value}
          />
        )
      })}
    </div>
  )
}
